import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getOrganismosPublicos } from 'app/features/OrganismosPublicos/organismosPublicosAPI';
const initialState = {
  List: [],
  status: 'idle',
};


export const getOrganismosPublicosAsync = createAsyncThunk(
  'OrganismosPublicos/fetchOrganismosPublicos',
  async data => {
    const response = await getOrganismosPublicos(data);
    return response.data;
  }
);

export const organismosPublicosSlice = createSlice({
  name: 'organismosPublicos',
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganismosPublicosAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getOrganismosPublicosAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.List = action.payload;
      })
      .addCase(getOrganismosPublicosAsync.rejected, (state, action) => {
        state.status = 'idle';
        console.error('Error:', action.error);
      });
  },
});

export const organismosPublicosList = (state) => state.organismosPublicosReducer.List;
export const organismosPublicosStatus = state => state.organismosPublicosReducer.status;

export default organismosPublicosSlice.reducer;
